import {AbstractJavascriptFunctionCallVO} from "./AbstractJavascriptFunctionCallVO";
import {JavascriptFunctionName} from "../JavascriptFunctionName";

export class JavascriptCallOnLoginCompleteVO implements AbstractJavascriptFunctionCallVO {
    /**
     * Defines parameters needed for calling "ggsOnLoginComplete" javascript function.
     *
     * Full documentation for javascript/flash interface see:
     * https://docs.google.com/a/goodgamestudios.com/document/d/1YEQHq6cQ3IsCBrwj2VO3nPe4Qu7JarFzKZWP2AgTQc0/edit
     *
     * @param accountId (String)
     * @param playerId (int)
     * @param instanceId (int)
     * @param networkId (int)
     * @param gameId (int)
     */
    public functionName = JavascriptFunctionName.ON_LOGIN_COMPLETE;
    public parameters = [];

    constructor(accountId: string, playerId: number, instanceId: number, networkId: number, gameId: number) {
        this.parameters.push(accountId, playerId, instanceId, networkId, gameId);
    }
}

